import Input from '@components/Input';
import { mapLocaleCodeToVat } from '@features/WordPress/utilities/helpers/locale';
import { useTranslation } from 'next-i18next';
import { Controller } from 'react-hook-form';

const BusinessInputFields = ({
  control,
  name,
  vatNumber,
  inputProps,
  locale,
}) => {
  const { t } = useTranslation(['account', 'common', 'checkout']);

  return (
    <>
      <Controller
        name="businessName"
        control={control}
        defaultValue={name || ''}
        render={({ field, fieldState }) => (
          <Input
            {...field}
            type="text"
            label={t('company', { ns: 'common' })}
            error={fieldState.error}
            {...inputProps}
          />
        )}
      />
      <Controller
        name="businessVatNumber"
        control={control}
        defaultValue={vatNumber || ''}
        rules={{
          required: true,
          pattern: {
            value: locale === 'de' ? /^(DE\s?)?[0-9]*$/ : /^[0-9]*$/,
            message: t('invalidVAT', { ns: 'common' }),
          },
          maxLength: {
            value: Array.isArray(mapLocaleCodeToVat(locale).vatLength)
              ? mapLocaleCodeToVat(locale).vatLength[1] // Use max length if range
              : mapLocaleCodeToVat(locale).vatLength, // Use single value for fixed length
            message: t('invalidVAT', { ns: 'common' }),
          },
          minLength: {
            value: Array.isArray(mapLocaleCodeToVat(locale).vatLength)
              ? mapLocaleCodeToVat(locale).vatLength[0] // Use min length if range
              : mapLocaleCodeToVat(locale).vatLength, // Use single value for fixed length
            message: t('invalidVAT', { ns: 'common' }),
          },
          validate: (value) => {
            if (locale === 'se' && value.substring(10, 12) !== '01') {
              return t('invalidVAT', { ns: 'common' });
            }
          },
        }}
        render={({ field, fieldState }) => (
          <Input
            {...field}
            type="text"
            label={t('vat', { ns: 'common' })}
            placeholder={mapLocaleCodeToVat(locale).placeholder}
            error={fieldState.error}
            onChange={(event) =>
              field.onChange(event.target.value.toString().replace(/\s/g, ''))
            }
            onBlur={(event) => {
              const newValue = event.target.value
                .toLowerCase()
                .replace(/dk|se|de|no|-/gi, '');
              if (locale === 'se' && typeof newValue === 'string') {
                switch (newValue.length) {
                  case 10:
                    field.onChange(`${newValue}01`);
                    break;
                  case 11:
                    if (newValue.substring(10, 11) === '1') {
                      field.onChange(`${newValue.substring(0, 10)}01`);
                    }
                    break;
                  default:
                    field.onChange(newValue);
                    break;
                }
              } else {
                field.onChange(newValue);
              }
              field.onBlur(event);
            }}
            {...inputProps}
          />
        )}
      />
    </>
  );
};

export default BusinessInputFields;
